import store from '../store/Store';
import getPublishedStatus from './getPublishedStatus';
import getFirstTimeUser from './getFirstTimeUser';

export default function checkBookingPageStatus(): boolean {
    return getPublishedStatus() || getFirstTimeUser() || store.isTurningOnBookingPage;
}
